module.exports = __webpack_public_path__ + "media/images/flags/32/Marshall-Islands-2faab9628c11705d8e50d041a22f3da1.png";